import { useEffect, useState } from 'react';

// Live Roof Types list (canonical 7) from /dropdowns/roof_types.
export function useRoofTypes(api) {
  const [roofTypes, setRoofTypes] = useState([]);
  useEffect(() => {
    if (!api) return;
    let cancel = false;
    api.get('/dropdowns/roof_types')
      .then(r => { if (!cancel) setRoofTypes(Array.isArray(r.data) ? r.data : (r.data?.options || [])); })
      .catch(() => {});
    return () => { cancel = true; };
  }, [api]);
  return roofTypes;
}
